import Vue from 'vue';

export default function() {

    // Core
    Vue.mixin(require('js-core/js/mixins/loggerChild').default);
    Vue.mixin(require('js-core/js/mixins/modal').default);
    Vue.mixin(require('js-core/js/mixins/mutate').default);
    Vue.mixin(require('js-core/js/mixins/persist').default);
    Vue.mixin(require('js-core/js/mixins/popup').default);
    Vue.mixin(require('js-core/js/mixins/refetchQuery').default);
    Vue.mixin(require('js-core/js/mixins/restartQueries').default);
    Vue.mixin(require('js-core/js/mixins/safe').default);

    // UI
    Vue.mixin(require('js-ui/js/mixins/alert').default);

    // App
    Vue.mixin(require('app/mixins/queryError').default);
    Vue.mixin(require('app/mixins/user').default);
}
